module.exports = __webpack_public_path__ + "static/media/trial2_1.11e3cfb4.png";